import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

const projectionHeaderStyles = makeStyles((theme: Theme) =>
    createStyles({
        projectionHeader: {
            backgroundColor: theme.palette.background.blue,
            color: theme.palette.common.black,
            position: "relative",
            zIndex: 2,
        },
        projectionHeaderCompanyContainer: {
            backgroundColor: "inherit",
            padding: theme.spacing(2, 2),
            display: "flex",
            flex: 1,
            zIndex: 2,
            justifyContent: "space-between",
            [theme.breakpoints.down("lg")]: {
                padding: theme.spacing(1.8, 3),
            },
        },
        companyContainer: {
            display: "flex",
            width: "25%",
            paddingRight: theme.spacing(2),
        },
        summaryHeaderCompanyLink: {
            display: "flex",
            alignItems: "center",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            color: theme.palette.primary.main,
            fontWeight: 400,
            fontSize: 12,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            "& .MuiTooltip-popper": {
                backgroundColor: theme.palette.others.darkerColor,
            },
        },
        linkIcon: {
            width: 14,
            height: 14,
            marginLeft: `${theme.spacing(1)} !important`,
        },
        actionsContainer: {
            display: "flex",
            justifyContent: "space-around",
        },
        projectionHeaderHiddenPanel: {
            backgroundColor: "inherit",
            padding: theme.spacing(0, 1.2),
            position: "absolute",
            zIndex: -1,
            top: "100%",
            left: 0,
            width: "100%",
            boxShadow: "0 2px 10px #646464",
        },
        pathBtnContainer: {
            display: "flex",
            alignItems: "center",
        },
    })
);

export default projectionHeaderStyles;
